export default __webpack_public_path__ + "static/media/greeting23.677e2308.png";